package com.sddamico.draftmachine.ds

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Span

/**
 * Phosphor icon weights. The brand uses **bold** for UI, **fill** for gears/status/feature
 * glyphs, and **regular** for in-field affordances. Phosphor is loaded from CDN in
 * build.gradle.kts (`@phosphor-icons/web@2.1.1`, regular/bold/fill weights).
 */
enum class IconWeight(val className: String) {
  Regular("ph"),
  Bold("ph-bold"),
  Fill("ph-fill"),
}

/**
 * Render a Phosphor icon glyph. Pass a bare Phosphor name (e.g. `"gear-six"`, `"lightning"`).
 * Size and color it via the [modifier] (`Modifier.fontSize(18.px).color(DmColor.brass300)`);
 * the glyph scales with `font-size`.
 */
@Composable
fun Icon(name: String, weight: IconWeight = IconWeight.Bold, modifier: Modifier = Modifier) {
  Span(
    attrs = Modifier
      .lineHeight(1)
      .then(modifier)
      .classNames(weight.className, "ph-$name")
      .toAttrs { attr("aria-hidden", "true") }
  ) {}
}
